import { render, staticRenderFns } from "./MoIntroFinish.vue?vue&type=template&id=e447a1e6&"
import script from "./MoIntroFinish.vue?vue&type=script&lang=ts&"
export * from "./MoIntroFinish.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports